import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../common/components/icons/AntIcon";

type Props = {
  refresh: () => void;
};

export const DashboardRefresh = ({ refresh }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("dashboard.actions.refresh")}>
      <span>
        <AntIcon onClick={refresh} style={{ fontSize: 24, cursor: "pointer" }} color="grey" type="sync" />
      </span>
    </Tooltip>
  );
};
